import { z } from 'zod';

/**
 * Validation schema for product update
 * Matches the server-side ProductFormFieldsSchema expectations
 */
export const updateProductSchema = z.object({
    name: z.string().min(1, 'Product name is required'),
    description: z.string().nullish(),
    unitLabel: z.string().nullish(),
    accountingCode: z.string().nullish(),
    taxCategory: z.string().nullish(),
    mappedTaxCategoryId: z.string().nullish(),
    active: z.boolean(),
    isShippable: z.boolean(),
    isTaxable: z.boolean(),
    autoSync: z.boolean(),
});

export type UpdateProductFormData = z.infer<typeof updateProductSchema>;

